//
// Module for the Plan Transfer wizard's Settings step
//
rs.module("participant/member/plantransfer/wizard/settingsstep",

    [ "common/select-helper" ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            var settingsDiv = $.js(jsSelectors.settingsDiv);
            var fromPlanSelect = settingsDiv.js(jsSelectors.fromPlanSelect);
            var fromEmployerSelect = settingsDiv.js(jsSelectors.fromEmployerSelect);
            var toPlanSelect = settingsDiv.js(jsSelectors.toPlanSelect);
            var loadingSpinner = settingsDiv.js(jsSelectors.loadingSpinner);
            var transferOptionRadioList = settingsDiv.js(jsSelectors.transferOptionRadioList);
            var transferOptionDeferredVestedRadio = settingsDiv.js(jsSelectors.transferOptionDeferredVestedRadio);
            var deferredVestedSelected = transferOptionDeferredVestedRadio.is(":checked");

            // Get Select Helpers since we're updating the selects' options and properties
            var fromPlanSelectHelper = selectHelper.getHelper(fromPlanSelect);
            var fromEmployerSelectHelper = selectHelper.getHelper(fromEmployerSelect);
            var toPlanSelectHelper = selectHelper.getHelper(toPlanSelect);

            if (deferredVestedSelected) {
                blankOutSelects();
            }

            fromPlanSelect.change(repopulateTransferToPlans);
            fromEmployerSelect.change(repopulateTransferToPlans);

            transferOptionRadioList.change(function () {
                deferredVestedSelected = transferOptionDeferredVestedRadio.is(":checked");
                enableDisableSelects();
            });

            // From Plan/Employer selection changed
            function repopulateTransferToPlans() {
                loadingSpinner.show();

                // get selected from plan/employer
                var selectedFromPlanKey = fromPlanSelect.val();
                var selectedFromEmployerKey = fromEmployerSelect.val();

                toPlanSelectHelper.loadOptionsFrom(
                    backendUrls.getTransferToPlanOptions,
                    {
                        transferFromPlanKey: selectedFromPlanKey,
                        transferFromEmployerKey: selectedFromEmployerKey
                    },
                    null,
                    function () { loadingSpinner.hide(); });    
            }

            // Enable or disable the select fields
            function enableDisableSelects() {
                fromPlanSelectHelper.setDisabled(deferredVestedSelected);
                fromEmployerSelectHelper.setDisabled(deferredVestedSelected);
                toPlanSelectHelper.setDisabled(deferredVestedSelected);

                // Add blank options and select them or remove blank options
                if (deferredVestedSelected) {
                    blankOutSelects();
                } else {
                    fromPlanSelectHelper.removeEmptyOption();
                    fromEmployerSelectHelper.removeEmptyOption();
                    toPlanSelectHelper.removeEmptyOption();
                }
            }

            function blankOutSelects() {
                fromPlanSelectHelper.prependOptions([{ Text: "", Value: "", Selected: true }]);
                fromEmployerSelectHelper.prependOptions([{ Text: "", Value: "", Selected: true }]);
                toPlanSelectHelper.prependOptions([{ Text: "", Value: "", Selected: true }]);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);